module.exports = "<div #svgCanvas class=\"mat-elevation-z4 sizeCorrector\">\n</div>"